import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'KeepersSmall',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className)
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.87039 0.853516H0.857422V15.2452H4.33983V11.2192H4.64199C4.90341 11.2192 5.28582 11.2192 5.46699 11.5615L7.06119 14.4603C7.40285 15.1242 7.80531 15.2452 8.55007 15.2452H11.1874L8.84847 10.6356C8.48613 9.9316 8.0636 9.77049 8.0636 9.77049V9.73037C8.0636 9.73037 8.446 9.52851 8.82841 8.86463L11.183 4.87945H7.39909L5.70834 7.97882C5.52717 8.30105 5.18489 8.30105 4.88335 8.30105H4.33983V2.0208C4.33983 0.994569 3.89662 0.853516 2.87039 0.853516Z",
      fill: "#39A8E2"
    }, null, -1)
  ]), 2))
}
}

})